import { IMenuItemProps } from '../components/services/GraphQLShared';

export const sidebar_menu: IMenuItemProps[] = [
  { id: 0, title: 'Home', icon: 'home', route: '/', key: '' },
  {
    title: 'Deals',
    key: 'Trading',
    subkey: 'TradingDealMenu',
    icon: 'handshake',
    color: '#0a2756',
    route: '#',
    id: 1,
  },
  {
    title: 'Deal Templates',
    key: 'DealDefinitionMenu',
    icon: 'handshake',
    description: '',
    route: '/Trading/DealDefinition/Index',
    id: 2,
    parentId: 1,
  },
  {
    title: 'Deal Instances',
    key: 'DealDefinitionInstanceMenu',
    icon: 'business-time',
    description: '',
    route: '/Trading/DealDefinitionInstance/Index',
    id: 3,
    parentId: 1,
  },
  {
    title: 'Deal Books',
    key: 'DealBook',
    icon: 'chalkboard-teacher',
    description: '',
    route: '/Trading/DealBook/OpenDealBook',
    id: 4,
    parentId: 1,
  },
  {
    title: 'Deal Book Meetings',
    key: 'DealBookMeeting',
    icon: 'user-tie',
    description: '',
    route: '/Trading/DealBook/OpenDealBookMeeting',
    id: 5,
    parentId: 1,
  },
  {
    title: 'Campaigns',
    key: 'Campaign',
    icon: 'shopping-cart',
    description: '',
    route: '/Trading/Campaign/Index',
    id: 7,
    parentId: 1,
  },
  {
    title: 'Snapshots',
    key: 'DealActivity',
    icon: 'images',
    description: '',
    route: '/Trading/DealActivity/Index',
    id: 8,
    parentId: 1,
  },
  {
    title: 'Forecast',
    key: 'Forecast',
    icon: 'calculator',
    color: '#0080ff',
    route: '#',
    id: 10,
  },
  {
    title: 'Revenue Forecasts',
    key: 'RevenueForecast',
    icon: 'tablet-alt',
    description: '',
    route: '/Trading/RevenueForecastStream/IndexForecast',
    id: 11,
    parentId: 10,
  },
  {
    title: 'Period Management',
    key: 'PeriodManagement',
    icon: 'folder-tree',
    description: '',
    route: '/Trading/AgencyProfile/IndexRevenuePeriod',
    id: 12,
    parentId: 10,
  },
  {
    title: 'Revenue Streams',
    key: 'RevenueStreams',
    icon: 'tablet-alt',
    description: '',
    route: '/Trading/RevenueStream/Index',
    id: 13,
    parentId: 10,
  },
  {
    title: 'VOD Commitment',
    key: 'CommitmentReporting',
    icon: 'file-text',
    route: '/Graph/Index/CommitmentReport',
    id: 14,
    parentId: 10,
  },
  {
    title: 'Reporting',
    key: 'Trading',
    subkey: 'TradingReportingMenu',
    icon: 'print',
    color: '#ffa800',
    route: '#',
    id: 20,
  },
  {
    title: 'Reporter',
    key: 'TradingReporter',
    icon: 'print',
    description: '',
    route: '/Trading/DealBook/Reporter',
    id: 21,
    parentId: 20,
  },
  {
    title: 'SMBC Spend',
    key: 'MasterSpend',
    icon: 'chart-area',
    description: '',
    route: '/Trading/MasterSpend/Index?Type=outcome',
    id: 22,
    parentId: 20,
  },
  {
    title: 'Trading Spend Targets',
    key: 'AnnualTarget',
    icon: 'chart-line',
    description: '',
    route: '/Trading/AnnualTarget/Index',
    id: 23,
    parentId: 20,
  },
  {
    title: 'VOD Book',
    key: 'GraphReports',
    icon: 'chart-pie',
    description: '',
    route: '/Graph/Index/VODReports',
    id: 24,
    parentId: 20,
  },
  {
    title: 'Configuration',
    key: 'Trading',
    subkey: 'TradingSetupMenu',
    icon: 'compass',
    color: '#00b5b1',
    route: '#',
    id: 30,
  },
  {
    title: 'Deal Setup for Media Types',
    key: 'DealMasterMediaCategory',
    icon: 'laptop',
    description: '',
    route: '/Trading/MasterMediaCategory/Index',
    id: 31,
    parentId: 30,
  },
  {
    title: 'SMBC Client Sets',
    key: 'MasterClientSet',
    icon: 'users',
    description: '',
    route: '/Trading/MasterClientSet/Index',
    id: 32,
    parentId: 30,
  },
  {
    title: 'SMBC Indexes',
    key: 'MasterSpendIndex',
    icon: 'chart-area',
    description: '',
    route: '/Trading/MasterSpend/Index?Type=setup',
    id: 33,
    parentId: 30,
  },
  {
    title: 'Bulk Operations',
    key: 'BulkControlPanel',
    icon: 'universal-access',
    description: '',
    route: '/Trading/DealDefinitionInstance/BulkPanel',
    id: 34,
    parentId: 30,
  },
  {
    title: 'Agencies and Clients',
    key: 'MDM',
    subkey: 'ClientsMenu',
    icon: 'city',
    color: '#ef5b2b',
    route: '#',
    id: 40,
  },
  {
    title: 'Companies and Agencies',
    key: 'Company',
    icon: 'sitemap',
    description: '',
    route: '/Companies/Company/Index',
    id: 41,
    parentId: 40,
  },
  {
    title: 'Clients',
    key: 'Client',
    icon: 'user',
    description: '',
    route: '/Clients/Client/Index',
    id: 42,
    parentId: 40,
  },
  {
    title: 'Client Sets',
    key: 'ClientSet',
    icon: 'folder',
    description: '',
    route: '/Clients/ClientSet/Index',
    id: 43,
    parentId: 40,
  },
  {
    title: 'Master Clients',
    key: 'MasterClient',
    icon: 'cubes',
    description: '',
    route: '/Clients/MasterClient/Index',
    id: 44,
    parentId: 40,
  },
  {
    title: 'SMBCs',
    key: 'ManagementType',
    icon: 'asterisk',
    description: '',
    route: '/Finance/ManagementType/Index',
    id: 45,
    parentId: 40,
  },
  {
    title: 'Cost Models',
    key: 'CostModel',
    icon: 'shopping-cart',
    description: '',
    route: '/Pricing/CostModel/Index',
    id: 46,
    parentId: 40,
  },
  {
    title: 'Media',
    key: 'MDM',
    subkey: 'MediaTypesMenu',
    icon: 'warehouse',
    color: '#001e62',
    route: '#',
    id: 50,
  },
  {
    title: 'Media Types',
    key: 'MediaType',
    icon: 'life-ring',
    description: '',
    route: '/MediaTypes/MediaType/Index',
    id: 51,
    parentId: 50,
  },
  {
    title: 'Sales Houses',
    key: 'SalesHouse',
    icon: 'shopping-cart',
    description: '',
    route: '/MediaVehicles/SalesHouse/Index',
    id: 52,
    parentId: 50,
  },
  {
    title: 'Media Vehicles',
    key: 'MediaVehicle',
    icon: 'car',
    description: '',
    route: '/MediaVehicles/MediaVehicle/Index',
    id: 53,
    parentId: 50,
  },
  {
    title: 'Media Groups',
    key: 'MediaVehicleGroup',
    icon: 'briefcase',
    description: '',
    route: '/MediaVehicles/MediaVehicleGroup/Index',
    id: 54,
    parentId: 50,
  },
  {
    title: 'Media Channels',
    key: 'Channel',
    icon: 'bullhorn',
    description: '',
    route: '/MediaVehicles/Channel/Index',
    id: 55,
    parentId: 50,
  },
  {
    title: 'Media Vehicle Types',
    key: 'MediaVehicleType',
    icon: 'info',
    description: '',
    route: '/MediaVehicles/MediaVehicleType/Index',
    id: 56,
    parentId: 50,
  },
  {
    title: 'Buying Routes',
    key: 'BuyingRoute',
    icon: 'map-signs',
    description: '',
    route: '/MediaVehicles/BuyingRoute/Index',
    id: 57,
    parentId: 50,
  },
  {
    title: 'Campaign Types',
    key: 'CampaignType',
    icon: 'road',
    description: '',
    route: '/MediaTypes/CampaignType/Index',
    id: 58,
    parentId: 50,
  },
  {
    title: 'Broadcast Types',
    key: 'BroadcastType',
    icon: 'rss',
    description: '',
    route: '/MediaTypes/BroadcastType/Index',
    id: 59,
    parentId: 50,
  },
  {
    title: 'Audiences',
    key: 'Target',
    icon: 'street-view',
    description: '',
    route: '/MediaTypes/Target/Index',
    id: 591,
    parentId: 50,
  },
  {
    title: 'General',
    key: 'MDM',
    subkey: 'GeneralMenu',
    icon: 'archive',
    color: '#0080ff',
    route: '#',
    id: 60,
  },
  {
    title: 'Country',
    key: 'Country',
    icon: 'globe',
    description: '',
    route: '/General/Country/Index',
    id: 61,
    parentId: 60,
  },
  {
    title: 'Region',
    key: 'Region',
    icon: 'map-pin',
    description: '',
    route: '/General/Region/Index',
    id: 62,
    parentId: 60,
  },
  {
    title: 'Language',
    key: 'Language',
    icon: 'sign-language',
    description: '',
    route: '/General/Language/Index',
    id: 63,
    parentId: 60,
  },
  {
    title: 'Location',
    key: 'Location',
    icon: 'map',
    description: '',
    route: '/General/Location/Index',
    id: 64,
    parentId: 60,
  },
  {
    title: 'Currency',
    key: 'Currency',
    icon: 'euro-sign',
    description: '',
    route: '/General/Currency/Index',
    id: 65,
    parentId: 60,
  },
  {
    title: 'Nationality',
    key: 'Nationality',
    icon: 'passport',
    description: '',
    route: '/General/Nationality/Index',
    id: 66,
    parentId: 60,
  },
  {
    title: 'Security',
    key: 'SecurityMenu',
    icon: 'users',
    route: '#',
    id: 100,
  },
  {
    title: 'Roles',
    key: 'Roles',
    icon: 'tablet-alt',
    route: '/Framework/Role/Index',
    description:'Manage security roles',
    id: 101,
    parentId: 100,
  },
  {
    title: 'Security Groups',
    key: 'SecurityGroups',
    icon: 'tablet-alt',
    route: '/Framework/Group/Index',
    description: 'Manage security groups',
    id: 102,
    parentId: 100,
  },
  {
    title: 'Users',
    key: 'Users',
    icon: 'tablet-alt',
    route: '/Framework/User/Index',
    description: 'Manage users and permissions',
    id: 103,
    parentId: 100,
  },
  {
    title: 'Users and Groups',
    key: 'UsersandGroups',
    icon: 'tablet-alt',
    route: '/Framework/User/IndexTree',
    description: 'Wizard for users management',
    id: 104,
    parentId: 100,
  },
  {
    title: 'Administration',
    key: 'AdminMenu',
    icon: 'wrench',
    route: '#',
    id: 200,
  },
  {
    title: 'Documents',
    key: 'Documents',
    icon: 'tablet-alt',
    route: '/Framework/DocumentFile/Index',
    description: 'Manage all documents',
    id: 201,
    parentId: 200,
  },
  {
    title: 'Application Settings',
    key: 'ApplicationSettings',
    icon: 'tablet-alt',
    route: '/Framework/AppSettings/Index',
    description: 'Set application settings',
    id: 202,
    parentId: 200,
  },
  {
    title: 'Audit Messages',
    key: 'AuditMessage',
    icon: 'desktop',
    route: '/Integration/AuditMessage/Index',
    description: 'Check integration results',
    id: 205,
    parentId: 200,
  },
  {
    title: 'Data Administration',
    key: 'DataAdministration',
    icon: 'tablet-alt',
    route: '/Framework/DataAdmin/Index',
    description: 'Query all data',
    id: 203,
    parentId: 200,
  },
  {
    title: 'Insights Viewer',
    key: 'InsightsViewer',
    icon: 'tablet-alt',
    route: '/Framework/InsightsViewer/Index',
    description: 'Query application logs',
    id: 204,
    parentId: 200,
  },
];
export const app_themes = [
  { id: 'light', text: 'Light' },
  { id: 'dark', text: 'Dark' },
];
